import { ReactNode } from 'react'
import { useLocation, useNavigate, useOutletContext } from 'react-router-dom'

import { Box, Tabs } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import hasFeature from 'modules/core/lib/hasFeature'
import i18n from 'modules/core/lib/i18n'

interface OutletContext {
  competenciesAvailable: boolean
}

interface Props {
  roleId: number
  actions?: ReactNode
}

export function RoleTabs({ roleId }: Props) {
  const location = useLocation()
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const { competenciesAvailable } = useOutletContext<OutletContext>()
  const hasNewCareerPath = hasFeature('dev_job_catalog_career_path')

  return (
    <Box position="relative" width="full">
      <Tabs currentId={location.pathname} onTabClicked={(to) => navigate(to)}>
        <Tabs.Tab
          id={navigation.employees.jobCatalog.role.fullPath({ id: roleId })}
          label={i18n.t('job_catalog.employees.title')}
          onClick={() => track(trackingEvents.jobCatalog.jobRoleLevelPageEmployees)}
        />

        <Tabs.Tab
          id={navigation.employees.jobCatalog.role.salaryRanges.fullPath({ id: roleId })}
          label={i18n.t('job_catalog.salary_ranges.title')}
          onClick={() => track(trackingEvents.jobCatalog.jobRoleLevelPageSalary)}
        />

        {competenciesAvailable ? (
          hasNewCareerPath ? (
            <Tabs.Tab
              id={navigation.employees.jobCatalog.role.careerPath.fullPath({ id: roleId })}
              label={i18n.t('job_catalog.career_path.title')}
              onClick={() => track(trackingEvents.jobCatalog.jobRolePageCareerPath)}
            />
          ) : (
            <Tabs.Tab
              id={navigation.employees.jobCatalog.role.competencies.fullPath({ id: roleId })}
              label={i18n.t('job_catalog.competencies.title')}
              onClick={() => track(trackingEvents.jobCatalog.jobRolePageCompetencies)}
            />
          )
        ) : (
          <></>
        )}
      </Tabs>
    </Box>
  )
}
